var map = {
	"./map_1971.png": 6543,
	"./map_1971_dark.png": 8984,
	"./map_1972.png": 4084,
	"./map_1972_dark.png": 229,
	"./map_1973.png": 5213,
	"./map_1973_dark.png": 430,
	"./map_1974.png": 2418,
	"./map_1974_dark.png": 6075,
	"./map_1975.png": 8456,
	"./map_1975_dark.png": 6732,
	"./map_1976.png": 4320,
	"./map_1976_dark.png": 2937,
	"./map_1977.png": 6425,
	"./map_1977_dark.png": 7618,
	"./map_1978.png": 4510,
	"./map_1978_dark.png": 5247,
	"./map_1979.png": 4503,
	"./map_1979_dark.png": 9872,
	"./map_1980.png": 9091,
	"./map_1980_dark.png": 9860,
	"./map_1981.png": 2906,
	"./map_1981_dark.png": 2115,
	"./map_1982.png": 9153,
	"./map_1982_dark.png": 8170,
	"./map_1983.png": 760,
	"./map_1983_dark.png": 9553,
	"./map_1984.png": 375,
	"./map_1984_dark.png": 5680,
	"./map_1985.png": 4590,
	"./map_1985_dark.png": 239,
	"./map_1986.png": 1317,
	"./map_1986_dark.png": 9190,
	"./map_1987.png": 9692,
	"./map_1987_dark.png": 3021,
	"./map_1988.png": 3707,
	"./map_1988_dark.png": 3996,
	"./map_1989.png": 2162,
	"./map_1989_dark.png": 3259,
	"./map_1990.png": 2136,
	"./map_1990_dark.png": 5105,
	"./map_1991.png": 4849,
	"./map_1991_dark.png": 4810,
	"./map_1992.png": 5866,
	"./map_1992_dark.png": 1715,
	"./map_1993.png": 6627,
	"./map_1993_dark.png": 1700,
	"./map_1994.png": 6668,
	"./map_1994_dark.png": 5853,
	"./map_1995.png": 533,
	"./map_1995_dark.png": 3926,
	"./map_1996.png": 1758,
	"./map_1996_dark.png": 2543,
	"./map_1997.png": 1751,
	"./map_1997_dark.png": 7168,
	"./map_1998.png": 1568,
	"./map_1998_dark.png": 233,
	"./map_1999.png": 3673,
	"./map_1999_dark.png": 4914,
	"./map_2000.png": 3435,
	"./map_2000_dark.png": 2700,
	"./map_2001.png": 2306,
	"./map_2001_dark.png": 8219,
	"./map_2002.png": 8393,
	"./map_2002_dark.png": 6578,
	"./map_2003.png": 2144,
	"./map_2003_dark.png": 9129,
	"./map_2004.png": 8015,
	"./map_2004_dark.png": 9304,
	"./map_2005.png": 5350,
	"./map_2005_dark.png": 6759,
	"./map_2006.png": 6557,
	"./map_2006_dark.png": 6814,
	"./map_2007.png": 3524,
	"./map_2007_dark.png": 9605,
	"./map_2008.png": 8819,
	"./map_2008_dark.png": 3956,
	"./map_2009.png": 9962,
	"./map_2009_dark.png": 2147,
	"./map_2010.png": 5536,
	"./map_2010_dark.png": 7945,
	"./map_2011.png": 9737,
	"./map_2011_dark.png": 4754,
	"./map_2012.png": 1554,
	"./map_2012_dark.png": 9259,
	"./map_2013.png": 6747,
	"./map_2013_dark.png": 9996,
	"./map_2014.png": 8292,
	"./map_2014_dark.png": 2853,
	"./map_2015.png": 1533,
	"./map_2015_dark.png": 2206,
	"./map_2016.png": 9766,
	"./map_2016_dark.png": 9015,
	"./map_2017.png": 3567,
	"./map_2017_dark.png": 2760,
	"./map_2018.png": 152,
	"./map_2018_dark.png": 5553,
	"./map_2019.png": 8545,
	"./map_2019_dark.png": 4170,
	"./map_2020.png": 3573,
	"./map_2020_dark.png": 9926,
	"./map_2021.png": 6060,
	"./map_2021_dark.png": 1853,
	"./map_2022.png": 4791,
	"./map_2022_dark.png": 3168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4991;